module.exports = __webpack_public_path__ + "components/signup/static/eye-4a08d6de27c74bbea0300efccf95b582.svg";